import React from 'react';
import PropTypes from 'prop-types';
import SMConst from 'lib/SMConst';
import SMReservationPayRequestView from 'components/reservations/SMReservationPayRequestView';
import SMUReservationChangePaymentView from './SMUReservationChangePaymentView';
import SMReservationHelper from 'components/helpers/SMReservationHelper';

class SMUReservationActionView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      currentUser: this.props.currentUser,
      reservation: this.props.reservation,
      delegate: this.props.delegate,
      isValid: true,
      isRequestViewOpen: false,
      isChangePaymentViewOpen: false
    };
  }
  
  cancel(e) {
    if(this.props.delegate && typeof this.props.delegate.cancelActionDidSelect === 'function'){
      this.props.delegate.cancelActionDidSelect(e);
    }
  }
  
  showReviewForm(e) {
    if(this.props.delegate && typeof this.props.delegate.showReviewFormActionDidSelect === 'function'){
      this.props.delegate.showReviewFormActionDidSelect(e);
    }
  }

  showRequestView(e) {
    e.preventDefault();
    if (!this.state.isValid) return;
    this.setState({
      isRequestViewOpen: true,
    });
  }

  // request delegate
  requestViewDidClose() {
    this.setState({
      isRequestViewOpen: false,
    });
  }
  
  showChangePaymentViewOpen(e) {
    e.preventDefault();
    this.setState({
      isChangePaymentViewOpen: true,
    });    
  }

  changePaymentViewDidClose() {
    this.setState({
      isChangePaymentViewOpen: false,
    });
  }

  render() {
    let reservation = this.props.reservation;
    let rows = [];
    if (reservation.method == SMConst.ReservationMethod.Inquiry ||
      (reservation.method == SMConst.ReservationMethod.Concierge && reservation.concierge.via == SMConst.ConciergeVia.Inquiry)){
      let room = reservation.room;
      rows.push(<a key="change" href={Routes.space_room_reservations_path(room.space.username, room.uid, {inquiry_id: reservation.uid})} className="button-green pt13 pb13 w180">予約リクエストに変更</a>);
    } else {
      if (reservation.can_be_cancelled) {
        rows.push(<a key="cancel" onClick={this.cancel.bind(this)} href="#" className="button-gray pt13 pb13 w180">{I18n.t("dashboard.label_000077")}</a>);
      }
      if (reservation.can_be_reviewed) {
        rows.push(<a key="review" href={Routes.dashboard_reservation_reputation_path(reservation.uid)} className="button-green pt13 pb13 pl5 w180 ml5" target="_blank">{I18n.t("dashboard.label_000139")}</a>);
      }
      if (reservation.can_be_paid) {
        rows.push(<a key="pay" onClick={this.showRequestView.bind(this)} className="button-green pt13 pb13 pl5 w180 ml5">{I18n.t("dashboard.label_000190")}</a>);
      }
      if (SMReservationHelper.isCompletedReservation(reservation)) {
        rows.push(<a key="itinerary" target="_blank" href={Routes.itinerary_path(reservation.uid)} className="button-green pt13 pb13 pl5 w180 ml5">{I18n.t("dashboard.label_000310")}</a>);
      }
      if (reservation.can_be_paid) {
        rows.push(
          <SMReservationPayRequestView
            key="pay_request"
            delegate={this}
            isOpen={this.state.isRequestViewOpen}
            currentUser={this.state.currentUser}
            reservation={reservation}
            only_pay={true}
            room={reservation.room}
            inquiry={false} />);
      }
      if (reservation.can_change_card) {
          rows.push(<a key="change_payment" onClick={this.showChangePaymentViewOpen.bind(this)} className="button-green pt13 pb13 pl5 w180 ml5">{I18n.t("dashboard.label_001001")}</a>);
          rows.push(
            <SMUReservationChangePaymentView
              key="payment"
              delegate={this}
              isOpen={this.state.isChangePaymentViewOpen}
              currentUser={this.state.currentUser}
              reservation={reservation}
              room={reservation.room} />);
      }
    }
    return(
      <p className="reserve-status-action-button reserve-status-buttonarea">
        {rows}
      </p>
    );
  }
}
SMUReservationActionView.propTypes = {
  reservation: PropTypes.object.isRequired,
  delegate: PropTypes.object,
};
export default SMUReservationActionView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/reservations/SMUReservationActionView.jsx